export const validateApiData = (apiData: any): boolean => {
  if (!apiData) {
    throw new Error('Dados da API não fornecidos');
  }
  return true;
};

export const logDataExtraction = (_apiData: any) => {
  // Silenced during bulk sync
};

export const logConversionSuccess = (_numero: string, _ordemServico: any) => {
  // Silenced during bulk sync
};
